import React from "react";
import PropTypes from "prop-types";
import { LineTruncate, Text, Triangle, Link } from "../../../atoms";
import ImageWrapper from "../../ImageWrapper";
import styled from "styled-components";
//Context

const SubWeb = ({
  className,
  onKeyDown,
  onKeyPress,
  href,
  native,
  data,
  ariaLabel,
  alt,
  onMouseMove,
  text,
  title,
  theme
}) => {
  return (
    <div className={className} onKeyDown={onKeyDown} onKeyPress={onKeyPress}>
      <Link
        href={href}
        rel="noopener noreferrer"
        tabIndex={0}
        display="block"
        hasHover={false}
        native={native}
      >
        <ImageWrapper
          data={data}
          aria-label={ariaLabel}
          alt={alt}
          hasEndpoint={false}
          onMouseMove={onMouseMove}
          endpoint={() => null}
          size="lg"
          useHeight
        />
        <div className="content-container d-flex flex-column">
          <div className="title-container d-flex flex-column flex-grow-1">
            <div className="triangle-container d-flex flex-column justify-content-center">
              <Triangle
                className="triangle"
                withContent={true}
                transform="rotate(-90deg)"
                position="absolute"
                left="-60px"
                contentColor={theme.components.header.subWeb.iconColor}
                color={theme.components.header.subWeb.bgColor}
                size="40px"
                contentSize="50px"
              />
            </div>
            <Text
              as="h3"
              fontWeight="400"
              color={theme.components.header.subWeb.titleColor}
              size="xLarge"
            >
              {title}
            </Text>
          </div>

          <div className="warning-container">
            <LineTruncate>
              <Text
                text={text}
                color={theme.components.header.subWeb.warning.textColor}
                size="small"
              />
            </LineTruncate>
            <Text
              text="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque."
              color={theme.components.header.subWeb.warning.textColor}
              marginTop="20px"
              fontWeight="400"
              size="mediumSmall"
            />
          </div>
        </div>
      </Link>
    </div>
  );
};

SubWeb.propTypes = {
  className: PropTypes.string,
  onKeyDown: PropTypes.func,
  onKeyPress: PropTypes.func,
  href: PropTypes.string,
  native: PropTypes.bool,
  data: PropTypes.array,
  ariaLabel: PropTypes.string,
  alt: PropTypes.string,
  onMouseMove: PropTypes.func,
  text: PropTypes.string,
  title: PropTypes.string,
  theme: PropTypes.object
};

const SubWebtWithStyles = styled(SubWeb)`
  position: relative;

  .content-container {
    background-color: ${props => props.theme.components.header.subWeb.bgColor};
    width: 350px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;

    .title-container {
      position: relative;
      .triangle-container {
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
      }
    }

    .title-container,
    .warning-container {
      padding: 30px;
    }

    .warning-container {
      min-height: 175px;
      background-color: ${props =>
        props.theme.components.header.subWeb.warning.bgColor};
    }
  }

  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575px) {
    .content-container {
      height: auto;
      width: 100%;
      top: initial;
      bottom: 0;

      .title-container {
        flex-grow: initial;
        .triangle-container {
          height: 0;
          top: -20px;
          width: 100%;
          align-items: center;
          .triangle {
            transform: rotate(0);
            left: initial;
          }
        }
      }

      .title-container,
      .warning-container {
        padding: 30px 15px;
      }

      .warning-container {
        min-height: initial;
      }
    }
  }
`;

export default SubWebtWithStyles;
